module.exports = __webpack_public_path__ + "img/binance.1c02c516.png";